define('home/views/TruncatedPostView',[
    'home/views/PostView',
    'home/templates/truncatedPost',
], function (
    PostView,
    truncatedPostTemplate
) {
    'use strict';

    var TruncatedPostView = PostView.extend({
        template: truncatedPostTemplate,
    });

    return TruncatedPostView;
});

